<template>
  <div class="page-content original-dialog">
    <div class="accounting-report-download">
      <h1 class="page-title">{{ $locale("sideMenu.accountingReportDownload") }}</h1>

      <!-- Search Area -->
      <el-row
        class="search-area"
        :gutter="10"
      >
        <el-col
          :span="15"
        >
          <MonthPickerGroup
              :start="filter.startMonth"
              :end="filter.endMonth"
              @setFatherDate="getDate_fn"
          ></MonthPickerGroup>
          <el-button
              class="egl-btn-yellow"
              @click="search_fn"
          >
            {{ $locale("global.search") }}
          </el-button>
        </el-col>
        <el-col
          class="ta-r"
          :span="9"
        >
          <el-button
            class="egl-btn-yellow right-align-btn"
            @click="openDialog()"
          >
            {{ $locale("global.create") }}
          </el-button>
          <el-button
            :class="this.tableData.some(item => !item.approve) ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="this.tableData.every(item => item.approve)"
            @click="approve_fn"
            class="right-align-btn">
              {{ $locale("global.approve") }}
          </el-button>
        </el-col>
      </el-row>

      <el-table
        class="egl-table list-table result-table"
        
        :data="tableData"
      >

        <el-table-column
          width="80"
          align="center"
          :label="$locale('global.change')"
        >
          <template
            slot-scope="scope"
          >
            <i
              class="el-icon-circle-check change"
              v-show="!scope.row.approve">
            </i>
          </template>
        </el-table-column>

        <template
          v-for="th in thead"
        >
          <el-table-column
            :min-width="180"
            :label="th.label"
            :prop="th.prop"
            :key="th.prop"
            :align="th.align"
            :formatter="valueFormat"
          >
          </el-table-column>
        </template>

        <el-table-column
          align="center"
          :label="$locale('global.control')"
        >
          <template
            slot-scope="scope"
          >
            <div
              class="handle"
            >
              <a
                @click="openDialog(scope.row.id)"
              >
                {{ $locale("global.detail") }}
              </a>
              /
              <a
                @click="delete_fn(scope.row)"
              >
                {{ $locale("global.delete") }}
              </a>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CommPagination
        :total="pageCount"
        :curPage="page"
        @current-change="choosePage"
      />

      <el-dialog
        class="egl-dialog"
        :visible="showDialog"
        :show-close="false"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        @opened="onDialogOpen"
      >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>{{ $locale("accountingReportDownload.dialog.title")}}</p>
          <el-tooltip
            placement="top"
            :content="$locale('accountingReportDownload.dialog.title')"
          >
            <span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>

      <div class="dialog-title">
        <div class="tipsBox">
          <div class="form-module-tit tipsBox">{{ $locale("global.basicInfo") }}</div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>
      <el-form ref="form" :model="form" @validate="validate">
        <el-row>
          <el-col>
            <el-form-item
              prop="theaterId"
              required
              :label="$locale('accountingReportDownload.dialog.theaterName')"
              :rules="[{
                required: true,
                message: 'Theater name is required',
              }]"
              :show-message="false"
            >
              <el-select
                multiple
                v-model="form.theaterId"
                :placeholder="$locale('accountingReportDownload.dialog.placeholder')"
                :disabled="readOnly"
              >
                <el-option
                  v-for="item in cinemaList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              prop="selectMonth"
              required
              :label="$locale('accountingReportDownload.dialog.month')"
              :rules="[{
                type: 'number',
                message: 'Month is required'
              }]"
              :show-message="false"
            >
              <div class="datepicker">
                <el-button
                  :class="readOnly ? 'egl-btn-gray' : 'egl-btn-yellow'"
                  @click="getCurMonth(-1)"
                >
                  <i class="el-icon-arrow-left"></i>
                </el-button>
                <el-date-picker
                  type="month"
                  v-model="form.selectMonth"
                  format="yyyy-MM"
                  value-format="timestamp"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  :disabled="readOnly"
                ></el-date-picker>
                <el-button
                  :class="readOnly ? 'egl-btn-gray' : 'egl-btn-yellow'"
                  @click="getCurMonth(1)"
                  >
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-table
              ref="reportListTable"
              class="egl-table"
              :data="reportList"
              @select="tableSelect"
              @select-all="tableSelect"
            >
              <el-table-column
                v-if="!readOnly"
                label=""
                width="80"
                type="selection"
              ></el-table-column>
              <el-table-column
                :label="$locale('accountingReportDownload.dialog.reportName')"
                prop="name"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$locale('global.control')"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    class="handle"
                    :class="readOnly && curDetailData.csvEnable && curDetailData.csvEnable[scope.row.type] ? '' : 'disable'"
                  >
                    <a @click="download_fn(curDetailData.id, scope.row.type, scope.row.name)">
                      {{ $locale("global.download") }}
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button
            class="egl-btn-white"
            @click="closeDialog"
          >
            {{ $locale("global.cancel") }}
          </el-button>
          <el-button
            v-if="!readOnly"
            :class="canSubmit ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="!canSubmit"
            class="right-align-btn"
            @click="submitForm()"
          >
            {{ $locale("global.save") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MonthPickerGroup from "@/components/MonthPickerGroup";
import { thead, formatData } from "@/assets/js/accountingReportDownload.js";
import { getAccountingReportList, createAccountingReport_fn, approveAccountingReport_fn,
removeAccountingReport_fn, exportAccountingReport_fn, AccountingReportDetail_fn } from "@/helpers/service/api/accountingReportDownload.js";
import { getCinemaList } from "@/helpers/service/api/common.js";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/accountingReportDownload.less";
import { requestAll } from "@/helpers/service/axiosPlugin";

export default {
  name: "AccountingReportDownload",
  data() {
    return {
      form: {
        theaterId: [],
        selectMonth: this.$moment().startOf("month").valueOf(),
        accountNum: "",
      },
      reportDownload: [],
      canSubmit: false,
      pickerOptions: {
        disabledDate: this.disableMonth
      },
      currentMonth: 0,
      filter: {
        startMonth: this.currentMonth,
        endMonth: this.currentMonth
      },
      // isApprove: this.isApprove(),
      cinemaList: [],
      originalData: [],
      thead: [],
      tableData: [],
      page: 0,
      pageCount: 0,
      showDialog: false,
      readOnly: false,
      reportList: [
        { id: 1, name: this.$locale("accountingReportDownload.dialog.dailyReport"), type: "DAY" },
        { id: 2, name: this.$locale("accountingReportDownload.dialog.filmFeeReport"), type: "PO" },
        { id: 3, name: this.$locale("accountingReportDownload.dialog.accountsPayable"), type: "OUT" },
        { id: 4, name: this.$locale("accountingReportDownload.dialog.filmFeePayment"), type: "PAY" },
      ],
      selectedCSV: [],
      reportListTableData: [],
      formValid: false,
      // curCSVEnable: {}
      curDetailData: {},
    };
  },
  methods: {
    tableSelect(value) {
      this.selectedCSV = [];
      // this.reportDownload = value;
      if (value.length > 0) {
        value.forEach(item => {
          this.selectedCSV.push(item.type);
        });
      } else {
        this.selectedCSV = [];
      }
      this.checkSubmit();
    },
    download_fn(id, type, name) {
      // console.log("click download");
      exportAccountingReport_fn({
        id,
        type,
      }).then(res => {
        if (typeof res === "string") {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
          const content = new TextEncoder().encode(res);
          const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
          const blobUrl = window.URL.createObjectURL(blob);
          const aElement = document.createElement("a");
          aElement.href = blobUrl;
          aElement.download = `${name}.csv`;
          aElement.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      });
    },
    checkSubmit() {
      this.canSubmit = this.formValid && this.selectedCSV.length > 0;
    },
    validate(fieldName, isValid) {
      this.formValid = (this.$refs.form.fields || []).every(e => (e.prop === fieldName && isValid) || e.validateState === "success");
      this.checkSubmit();
    },
    submitForm() {
      // console.log("form submitted");
      createAccountingReport_fn({
        brandId: window.localStorage.getItem("brandId"),
        cinemas: this.cinemaFormat(this.form.theaterId),
        createAccountId: window.localStorage.getItem("accountId"),
        csvEnable: this.csvEnableFormat(this.selectedCSV),
        month: this.form.selectMonth
      }).then(res => {
        if (res.success) {
          this.closeDialog();
          countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: this.search_fn() });
        }
      });
    },
    cinemaFormat(arr) {
      let _arr = [];
      arr.forEach(item => {
        _arr.push({
          cinemaId: item,
          cinemaName: this.cinemaList.find(cinema => cinema.value === item).label
        });
      });
      return _arr;
    },
    csvEnableFormat(arr) {
      let obj = {};
      if (arr.length > 0) {
        arr.forEach(item => {
          obj[item] = false;
        });
      }
      return obj;
    },
    getCurMonth(num = 0) {
      const currentMonth = this.$moment().startOf("month").valueOf();
      const updatedMonth = num === 0 ? currentMonth : this.$moment(this.form.selectMonth).subtract(-(num), "months").valueOf();
      this.form.selectMonth = updatedMonth > currentMonth ? currentMonth : updatedMonth;
    },
    disableMonth(time) {
      return time.getTime() > this.$moment(this.selectMonth).startOf("month").valueOf();
    },
    search_fn() {
      const that = this;
      const requestMonth = {
        brandId: window.localStorage.getItem("brandId"),
        monthStart: this.$moment(that.filter.startMonth).startOf("month").valueOf(),
        monthEnd: this.$moment(that.filter.endMonth).endOf("month").valueOf(),
        page: this.page,
        pageSize: 10
      };

      // requestAll([ getAccountingReportList(requestMonth) ]).then(res => {
      //   let { notApprove, tableData } = formatData(res[0].data.data);

      //   // this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
      //   this.pageCount = res[0].data.count || 0;
      //   that.tableData = tableData;
      //   that.notApprove = notApprove;
      //   that.originalData = res[0].data.data;
      // });
      getAccountingReportList(requestMonth).then(res => {
        this.pageCount = res.data.count;
        this.tableData = res.data.data;
        this.tableData.forEach(item => {
          let str = "";
          item.cinemas.forEach((cinema, idx) => {
            str += idx < item.cinemas.length - 1 ? cinema.cinemaName + "、" : cinema.cinemaName;
          });
          item.cinemaName = str;
        });
      });
      // requestAll([ getAccountingReportList(requestMonth) ]).then(res => {
      //   let { notApprove, tableData } = formatData(res[0].data.data);

      //   // this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
      //   this.pageCount = res[0].data.count || 0;
      //   that.tableData = tableData;
      //   that.notApprove = notApprove;
      //   that.originalData = res[0].data.data;
      // });
    },
    getDate_fn(obj = {}) {
      this.filter = {
        startMonth: obj.startMonth,
        endMonth: obj.endMonth,
      };
    },
    choosePage(page) {
      this.page = page - 1;
      this.search_fn();
    },
    onDialogOpen() {
      this.$refs.form.validate(() => {});
    },
    openDialog(id = "") {
      // this.form.theaterId = [];
      this.readOnly = id !== "";
      this.showDialog = true;
      if(id !== "") {
        // const detailObj = this.tableData.find(data => data.id === id);
        AccountingReportDetail_fn({ id }).then(res => {
          const detailObj = res.data;
          detailObj.cinemas.forEach(item => {
            this.form.theaterId.push(item.cinemaId);
          });
          this.form.selectMonth = detailObj.month;
          // this.curCSVEnable = detailObj.csvEnable;
          this.curDetailData = detailObj;
        });
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.form.theaterId = [];
      // this.form.selectMonth = this.$moment().valueOf();
    },
    delete_fn(obj) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${obj.cinemaName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        removeAccountingReport_fn({ id: obj.id }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully"), callback: this.search_fn() });
          }
        });
      });
    },
    approve_fn() {
      approveAccountingReport_fn().then(res => {
        if (res.success) {
          countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: this.search_fn() });
        }
      });
    },
    getCinemaList_fn() {
      getCinemaList({ page: 0, pageSize: 9999 }, false, false).then(res => {
        this.cinemaList = res.data.data.map(({ id, name }) => {
          return {
            value: id,
            label: name
          };
        });
      });
    },
    valueFormat(row, column, cellValue) {
      switch(column.property) {
      case "month":
        return this.$moment(cellValue).format("YYYY-MM");
      case "createTime":
        return this.$moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      default:
        return cellValue;
      }
    }
    // isApprove() {
    //   return this.tableData.some(item => !item.approve);
    // }
  },
  mounted() {
    let th = thead();
    const currentDate = this.$moment().valueOf();
    this.filter = {
      startMonth: currentDate,
      endMonth: currentDate
    };
    this.currentDate = currentDate;
    this.thead = th;
    this.getCinemaList_fn();
    this.search_fn();
    // this.reportListTableData = this.reportList.map(list => {
    //   return {
    //     id: list.id,
    //     reportName: list.name
    //   };
    // });
  },
  components: {
    MonthPickerGroup,
    CommPagination,
  },
};
</script>
